module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-18.c7082da7.png";